import {Injectable} from "@angular/core";
import {FactoryInterface} from "../factory.interface";

@Injectable()
export class DivisionsFactory implements FactoryInterface {
    build() {
        return [
            {code: 1, label: "Exponencial Business"},
            {code: 2, label: "E-Commerce e Varejo"},
            {code: 3, label: "Franca"},
            {code: 4, label: "Projetos Especiais"},
            {code: 5, label: "Inovação"},
            {code: 6, label: "LinkAPI"},
            {code: 18, label: "Orange Ventures"},
            {code: 19, label: "Imagine"},
            {code: 20, label: "FC PT"},
        ]
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/factories/dropdown/divisions.factory.ts